import { Link } from "react-router-dom";
import { navLinks, siteBrand, siteStats } from "@/mocks/site";
import { topics } from "@/mocks/melons";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-900 text-secondary-100">
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-foreground-950">
                瓜
              </span>
              <span className="font-heading text-xl font-bold text-background-50">{siteBrand.name}</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-200">
              {siteBrand.slogan}。用可核对的时间线与未删减原稿，替代情绪化的碎片传闻。
            </p>
            <p className="mt-5 text-sm text-secondary-300">
              <i className="ri-mail-line mr-2"></i>
              {siteBrand.email}
            </p>
            <p className="mt-2 text-sm text-secondary-300">{siteBrand.updateNote}</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <Link to="/" className="transition-colors hover:text-accent-300">站内导航</Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-secondary-200 transition-colors hover:text-accent-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <Link to="/topics" className="transition-colors hover:text-accent-300">瓜田分类</Link>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
              {topics.map((topic) => (
                <li key={topic.slug}>
                  <Link
                    to={`/topics?topic=${topic.slug}`}
                    className="text-secondary-200 transition-colors hover:text-accent-300"
                  >
                    {topic.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-6 border-t border-secondary-700 pt-8 sm:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label}>
              <p className="font-heading text-2xl font-bold text-accent-300">{stat.value}</p>
              <p className="mt-1 text-xs tracking-wide text-secondary-300">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-secondary-700 pt-6 text-xs text-secondary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteBrand.name} · 内容基于公开信息整理，仅供阅读与讨论</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/faq" className="transition-colors hover:text-accent-300">内容原则</Link>
            <Link to="/about" className="transition-colors hover:text-accent-300">关于我们</Link>
            <a
              href={`mailto:${siteBrand.email}`}
              rel="nofollow"
              className="transition-colors hover:text-accent-300"
            >
              联系编辑部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}